import { adminHttpClient } from '../commons/adminHttpClient'
import { AppConfigurationResponse } from './getAllAppConfigurations'

export const AppConfigurationKeys = {
  DocReviewTurnAroundInformation: 'DocReviewTurnAroundInformation',
}

const getAppConfiguration = (key: string): Promise<AppConfigurationResponse> => {
  return adminHttpClient.get(`/AppConfigurations/${key}`, {})
}

export default getAppConfiguration
